import MiddlePanel from 'Components/MiddlePanel/MiddlePanel';
import Panel from 'Components/Panel/Panel';
import { useEffect, useState } from 'react';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import InputField from 'Components/Input/InputField';
import TextAreaField from 'Components/TextAreaField/TextAreaField';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import MandatoryIconField from 'Components/MandatoryIconField';

const NewItemMonthPanel = ({
    itemInValidation,
    dsItem,
    currentMonth,
    showNewItemMonthPanel,
    onUpdatePanelCostSpreadsheet,
    onUpdateShowNewItemMonthPanel,
    onUpdateReloadSalaryBenefitsCost
}) => {
    const [quantityItem, setQuantityItem] = useState(null);
    const [valueItem, setValueItem] = useState(null);
    const [dsObservation, setDsObservation] = useState(null);

    const [loadingNewItemMonthPanel, setLoadingNewItemMonthPanel] = useState(null);

    const panelListStyle = {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%'
    };

    const styleButtonsMonth = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        alignItems: 'center'
    }

    function cancelFunction() {
        onUpdateShowNewItemMonthPanel(false);
        resetVariables();
    }

    function resetVariables() {
        setValueItem('');
        setQuantityItem('');
        setDsObservation('');
    }

    async function postFunction() {
        try {
            setLoadingNewItemMonthPanel(true)
            const response = await ExecuteAxios.api('post', `/cost-day/unique-selected-month/`, {
                itemId: itemInValidation,
                quantityItem: quantityItem,
                valueItem: valueItem,
                observation: dsObservation,
                currentMonth: currentMonth
            });

            if (response) {
                onUpdatePanelCostSpreadsheet(true)
                onUpdateReloadSalaryBenefitsCost(true)
                resetVariables();
                onUpdateShowNewItemMonthPanel(false)
            }
            return response
        } finally {
            setLoadingNewItemMonthPanel(false)
        }
    }

    const styleRowsAttributes = {
        display: 'flex',
        flexDirection: 'row',
        width: '100%'
    }

    const textAreaStyle = {
        width: '100%',
        height: '60px',
        resize: 'none',
        fontSize: '16px'
    }

    useEffect(() => {
        resetVariables()
    }, [showNewItemMonthPanel])

    return (
        <MiddlePanel isVisible={showNewItemMonthPanel}>
            <LoadingIndicator loaded={!loadingNewItemMonthPanel}>
                <Panel style={{
                    width: '400px',
                    height: '100%',
                    padding: '5px',
                    borderRadius: '10px',
                    backgroundColor: '#f5f5f5',
                    border: '1px solid #ccc',
                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 30%)'
                }}>
                    <Panel titlePage={'Novo item'}
                        style={panelListStyle}
                        canViewCRUD={true}
                        postFunction={postFunction}
                        canSaveAfterNewRecord={valueItem && quantityItem}
                        cancelFunction={cancelFunction}
                        enableNewRecord={true}
                        canNewRecord={true}
                        enableDelete={true}
                        canDelete={true}
                        recordsSelected={[]}
                        inserting={true}>
                        <Panel style={styleButtonsMonth}>

                            <div style={styleRowsAttributes}>
                                <div id='attribute-control' style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <span className='span-role-control'>Item</span>
                                        <MandatoryIconField />
                                    </div>
                                    <InputField
                                        setAttribute={null}
                                        value={dsItem}
                                        readOnly={true}
                                        disabled={true}
                                        style={{ width: '100%' }}
                                    />
                                </div>
                            </div>

                            <div style={styleRowsAttributes}>
                                <div id='attribute-control' style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <span className='span-role-control'>Quantidade real</span>
                                        <MandatoryIconField />
                                    </div>
                                    <InputField
                                        setAttribute={setQuantityItem}
                                        value={quantityItem}
                                        readOnly={false}
                                        disabled={false}
                                        style={{ width: '100%' }}
                                    />
                                </div>

                                <div id='attribute-control' style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <span className='span-role-control'>Valor real</span>
                                        <MandatoryIconField />
                                    </div>
                                    <InputField
                                        setAttribute={setValueItem}
                                        value={valueItem}
                                        readOnly={false}
                                        disabled={false}
                                        style={{ width: '100%' }}
                                        mask={'money'}
                                    />
                                </div>
                            </div>

                            <div style={styleRowsAttributes}>
                                <div id='attribute-control' style={{ width: '100%' }}>
                                    <span className='span-role-control'>Observação</span>
                                    <TextAreaField
                                        setAttribute={setDsObservation}
                                        value={dsObservation}
                                        type="text"
                                        readOnly={false}
                                        disabled={false}
                                        style={textAreaStyle}
                                    />
                                </div>
                            </div>

                        </Panel>
                    </Panel>
                </Panel>
            </LoadingIndicator>
        </MiddlePanel >
    );
}

export default NewItemMonthPanel;
